// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ae3e85ab","833":"b7f3d6cb","977":"0296d865"}[chunkId] + ".chunk.js";
};